export class AnalyzerVolatilityLine {
    public isActive: boolean;
    public value: number;
    public width: number;
    public color: string;
}
